
import './App.scss';
import Header from './components/header/Header';
import Products from './components/products/Products';
import{products,categories} from "./helpers/data";

function App() {
  // console.log(products);
  return (
    <div>  
      <Header categories={categories} text="ProductList"/>
      <Products products={products}/>

    </div>
  );
}

export default App;
